import { makeObservable } from 'mobx';
import { AssureAdminApiClientStore } from './assure-admin-api-client.store';
import { RepositoriesApiClient } from '../api';
import { AssureBaseStore, IAssureStoreConstructorOptions } from './assure-base.store';
import { ICreateRepositoryRequest, IGetRepositoryRequest, RepositoryDto, TUpdateRepositoryRequest } from 'dto/repository.dto';

export type IRepositoriesStoreConstructorOptions = IAssureStoreConstructorOptions;

export class RepositoriesStore extends AssureBaseStore<RepositoriesApiClient, any> {

    private readonly _apiClientStore: AssureAdminApiClientStore;

    public constructor(
        options: IRepositoriesStoreConstructorOptions,
    ) {
        super(options);
        makeObservable(this);
        this._apiClientStore = options.apiClientStore;
    }

    protected get apiClient(): RepositoriesApiClient {
        return this._apiClientStore.apiClients.repositories;
    }

    public async createRepository(accountId: number, accountUuid: string, params: ICreateRepositoryRequest): Promise<RepositoryDto> {
        const response = await this.apiClient.createRepository(accountId, accountUuid, params);
        return new RepositoryDto(response.repository);
    }

    public async getRepositories(accountId: number, accountUuid: string, params?: IGetRepositoryRequest): Promise<RepositoryDto[]> {
        const response = await this.apiClient.getRepositories(accountId, accountUuid, params);
        return response.repositories.map((repo: any) => new RepositoryDto(repo));
    }

    public async updateRepository(accountId: number, uuid: string, params: TUpdateRepositoryRequest): Promise<boolean> {
        const response = await this.apiClient.updateRepository(accountId, uuid, params);
        return response?.updated;
    }

    public async deleteRepository(accountId: number, uuid: string): Promise<boolean> {
        const response = await this.apiClient.deleteRepository(accountId, uuid);
        return response?.deleted;
    }
}
